import { Button } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { LoggedOutGeneratorSection } from '../LoggedOutCodeGenerator.types'
import { selectSectionGroup } from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'
import useTranslation from 'next-translate/useTranslation'

export const BackButton: FC = () => {
  const { t } = useTranslation('logged-out-generator')
  const { locgService } = useGlobalServices()
  const currentSection = useSelector(locgService, selectSectionGroup)

  const BACK_TARGET_MAP: Partial<
    Record<
      LoggedOutGeneratorSection,
      { targetSection: LoggedOutGeneratorSection; onClick: () => void; buttonText: string }
    >
  > = {
    [LoggedOutGeneratorSection.ScanDestination]: {
      targetSection: LoggedOutGeneratorSection.CodeDesign,
      onClick: () => locgService.send({ type: LoggedOutGeneratorSection.CodeDesign }),
      buttonText: t('LoggedOutGenerator.FormActionButtons.BackToDesign')
    },
    [LoggedOutGeneratorSection.CodeDesign]: {
      targetSection: LoggedOutGeneratorSection.ScanDestination,
      onClick: () => locgService.send({ type: LoggedOutGeneratorSection.ScanDestination }),
      buttonText: t('LoggedOutGenerator.FormActionButtons.BackToScanDestination')
    },
    [LoggedOutGeneratorSection.SignUp]: {
      targetSection: LoggedOutGeneratorSection.ScanDestination,
      onClick: () => {
        locgService.send({ type: LoggedOutGeneratorSection.ScanDestination })
      },
      buttonText: t('LoggedOutGenerator.FormActionButtons.BackToScanDestination')
    }
  }

  return (
    <Button
      size="small"
      color="secondary"
      variant="text"
      onClick={BACK_TARGET_MAP[currentSection]?.onClick}
      sx={{ ml: -3 }} // left-align button icon to the start of the heading below it
      data-heap-id="LoggedOutGenerator_BackButton"
      data-section={currentSection}
      data-target={BACK_TARGET_MAP[currentSection]?.targetSection}
    >
      {BACK_TARGET_MAP[currentSection]?.buttonText}
    </Button>
  )
}
